<div
  class="content-card class-card body-under-media"
  tabindex="0"
  [ngClass]="[orientation || '', 'bundle-' + data.bundle]"
  [class.locked]="data.isLocked"
  [class.disabled]="!data.active"
  [attr.data-cy]="'class-card-' + data.id"
  (click)="cardClick.emit($event)">
  <div class="content-card__media">
    <div class="content-card__media--image"
      [placeholderImage]="!data?.mediaImage && data.bundle"
      [cropImage]="(data?.mediaImage | preSignedUrl | async) || data.image"
      [crop]="data.mediaImage?.crop"
      imageWidth="400">
    </div>
    <div class="content-card__badges">
      @if (data.isLocked) {
        <div
          class="content-card__badges--item badge-dark"
        [matTooltip]="data.selectiveLockingItems?.length
          ? ('COMMON.selective_locked_list' | translate:{content: selectiveLockingItems})
          : ('ERRORS.content_locked' | translate)">
          <lib-icon icon="lock-simple" [size]="16"></lib-icon> {{'MODULE_LESSON_CARD.locked' | translate}}
        </div>
      }
    </div>
  </div>
  <div class="content-card__body">
    @if (showType) {
      <div class="content-card__body--label">
        <div class="content-card__body--label-item text-uppercase">
          {{ data | bundleLabel | async }}
        </div>
      </div>
    }
    <div class="content-card__body--title">{{data.title}}</div>
    <div class="content-card__body--footer">
      @if (data.progress && !hideProgress) {
        <div class="content-card__body--footer-item progress-indicator" [style.order]="cardsSettings?.[data.bundle]?.progress?.weight">
          @if (data.progress !== 100) {
            @if (data.progress !== 1) {
              <mat-progress-bar class="default-theme" mode="determinate" [value]="data.progress" data-cy="card-progress-bar" aria-label="Progress"></mat-progress-bar> {{data.progress}}%
            } @else {
              <lib-icon icon="circle-dashed" [size]="16"></lib-icon> {{'COMMON.in_progress' | translate}}
            }
          } @else {
            <div class="content-card__body--footer-item completed-indicator">
              <lib-icon icon="check-circle" [fill]="true"></lib-icon> {{'MODULE_LESSON_CARD.completed' | translate}}
            </div>
          }
        </div>
      }
      @if (data.coursesCount && cardsSettings?.class?.content?.visible) {
        <div class="content-card__body--footer-item" [style.order]="cardsSettings?.class?.content?.weight">
          <lib-icon icon="stack" [size]="16"></lib-icon> {{'COMMON.n_courses' | translate:{count: data.coursesCount} }}
        </div>
      }
      @if (data.leaderboardPoints && leaderboardEnabled && cardsSettings?.class?.leaderboardPoints?.visible) {
        <div [style.order]="cardsSettings?.class?.leaderboardPoints?.weight" [matTooltip]="'COMMON.content_complete_points' | translate:{points: data.leaderboardPoints}" class="content-card__body--footer-item">
          <lib-icon icon="currency-eth" [size]="16"></lib-icon> {{data.leaderboardPoints}} {{'LEADERBOARD.pts' | translate | lowercase}}
        </div>
      }
      @if (data.achievements?.length && achievementsEnabled && cardsSettings?.class?.achievements?.visible) {
        <div [style.order]="cardsSettings?.class?.achievements?.weight" [matTooltip]="'COMMON.content_complete_achievements' | translate:{count: data.achievements?.length, content: achievementsTitle}" class="content-card__body--footer-item">
          <lib-icon icon="medal" [size]="16"></lib-icon> {{'COMMON.achievement' | translate}}
        </div>
      }
      @if (data.certifications?.length && certificatesEnabled &&cardsSettings?.class?.certificate?.visible) {
        <div [style.order]="cardsSettings?.class?.certificate?.weight" [matTooltip]="'COMMON.content_complete_certificate' | translate:{ certificate: certificationsTitle }" class="content-card__body--footer-item">
          <lib-icon icon="certificate" [size]="16"></lib-icon> {{'COMMON.certificate' | translate}}
        </div>
      }
    </div>
  </div>
</div>
